export const initialState = {
 // filter: [],
 status: "All", // featured
 search: "",
};
